<app-header></app-header>
<div class="container-fluid">
  <h2>FAANG Files</h2>
  <hr>

  <div fxLayoutGap="2%" fxLayout="row" fxLayout.lt-md="column">
    <div fxFlex="17">
      <app-filter title="Standard" [filterSize]=3></app-filter>
      <app-filter title="Species" [filterSize]=3></app-filter>
      <app-filter title="Assay type" [filterSize]=3></app-filter>
      <app-filter title="Target" [filterSize]=3></app-filter>
      <app-filter title="Instrument" [filterSize]=3></app-filter>
      <app-filter title="Paper published" [filterSize]=2></app-filter>
      <app-filter title="Project" [filterSize]=4></app-filter>
    </div>

    <div fxFlex="83" class="table-responsive">
      @if (hasActiveFilters()) {
        <div>
          @defer (when hasActiveFilters()) {
            <app-active-filter></app-active-filter>
          }
          @loading {
            Loading active filters...
          } @error {
            Failed to load active filters!
          }
          <button mat-raised-button (click)="removeFilter()">Remove all filters</button>
          <button mat-raised-button
                  matTooltip="Subscribe to selected File entries"
                  (click)="openSubscriptionDialog()">
            <div class="subscription-icon">
              <mat-icon>email</mat-icon>
            </div>
          </button>
          <hr>
        </div>
      }
      <button mat-raised-button style="background-color: green; color: white;" (click)="onDownloadData()" [disabled]="downloading">
        Download data
      </button>
      @if (downloadData) {
        <button (click)="downloadFile('csv')" mat-raised-button>
          Export as CSV file
        </button>
      }
      @if (downloadData) {
        <button (click)="downloadFile('txt')" mat-raised-button>
          Export as Tabular file
        </button>
      }

      @if (downloading) {
        <div style="padding: 15px">
          <mat-spinner [diameter]="30"></mat-spinner>
        </div>
      }

      <app-table-server-side  [display_fields]="displayFields"
                              [column_names]="columnNames"
                              [indexDetails]="indexDetails"
                              [templates]="templates"
                              [filter_values]="filter_field"
                              [apiFunction]="loadTableDataFunction"
                              [query]="query"
                              [defaultSort]="defaultSort">
      </app-table-server-side>
    </div>
  </div>
</div>

<ng-template #fileNameTemplate let-item>
  <a style="cursor: pointer" target="_blank" [routerLink]="item['fileName']">{{item['fileName']}}</a>
</ng-template>

<ng-template #paperPublishedTemplate let-item>
  @if (wasPublished(item['paperPublished'])) {
    <div [ngClass]="isGreen(item['paperPublished'])">
      <i class="material-icons">check_circle</i>
    </div>
  }
  @if (!wasPublished(item['paperPublished'])) {
    <div [ngClass]="isGreen(item['paperPublished'])">
      <i class="material-icons">highlight_off</i>
    </div>
  }
</ng-template>
